const baseOrderedListData = { indentation: 0 };
export const OrderedListData = {
    fromJSON(object) {
        const message = Object.assign({}, baseOrderedListData);
        message.indentation =
            object.indentation !== undefined && object.indentation !== null
                ? Number(object.indentation)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.indentation !== undefined && (obj.indentation = Math.round(message.indentation));
        return obj;
    },
};
const baseBulletedListData = { indentation: 0 };
export const BulletedListData = {
    fromJSON(object) {
        const message = Object.assign({}, baseBulletedListData);
        message.indentation =
            object.indentation !== undefined && object.indentation !== null
                ? Number(object.indentation)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.indentation !== undefined && (obj.indentation = Math.round(message.indentation));
        return obj;
    },
};
//# sourceMappingURL=node_list.js.map